import type { BranchKey, WorkspaceKey } from '@festina-life/api'

import { useBaseBranchWorkspaces } from '../../hooks/useBaseBranchWorkspaces'
import { conciseWorkspaceToWorkspaceKey } from '../branchesPanel/branchDetails/branchWorkspaces/helpers'
import { WorkspaceCreationModal } from '../workspaceCreationModal/WorkspaceCreationModal'
import { WorkspaceSelectorOrCreator } from './WorkspaceSelectorOrCreator'

type Props = {
  isOpen: boolean
  onCancel: () => void
  onSelected: (workspaceKey: WorkspaceKey) => void
  baseBranch: BranchKey
}

export const WorkspaceSelector = ({
  isOpen,
  onSelected,
  onCancel,
  baseBranch,
}: Props) => {
  const existentWorkspaceForBaseBranch = useBaseBranchWorkspaces(baseBranch)
  const workspacesForBaseBranch = existentWorkspaceForBaseBranch.map(
    (conciseWorkplace) =>
      conciseWorkspaceToWorkspaceKey({
        workspace: conciseWorkplace,
        server: baseBranch.server,
      }),
  )

  return workspacesForBaseBranch.length > 0 ? (
    <WorkspaceSelectorOrCreator
      options={workspacesForBaseBranch}
      baseBranch={baseBranch}
      onCancel={onCancel}
      onSelected={onSelected}
    />
  ) : (
    <WorkspaceCreationModal
      onCreated={onSelected}
      baseBranch={baseBranch}
      isOpen={isOpen}
      onCancel={onCancel}
    />
  )
}
